import React from 'react';
import { EvaluationCriterion } from '../../types';
import styles from './CriteriaScoresSection.module.css';

interface CriteriaScoresSectionProps {
  criteriaEvaluations: Record<string, EvaluationCriterion>;
  showComments?: boolean;
}

const criteriaLabels = {
  originality_risk: 'Originalidad y Riesgo',
  national_relevance: 'Relevancia Nacional',
  global_scalability: 'Escalabilidad Global',
  international_collaboration: 'Colaboración Internacional',
  technical_viability: 'Viabilidad Técnica',
  results_quality: 'Calidad de Resultados',
};

const CriteriaScoresSection: React.FC<CriteriaScoresSectionProps> = ({
  criteriaEvaluations,
  showComments = true,
}) => {
  return (
    <div className={styles.criteriaSection}>
      <h2>Puntuaciones por Criterio</h2>
      <div className={styles.criteriaList}>
        {Object.entries(criteriaEvaluations).map(([criterion, evaluation]) => (
          <div key={criterion} className={styles.criteriaRow}>
            <div className={styles.criteriaHeader}>
              <h3 className={styles.criteriaTitle}>
                {criteriaLabels[criterion as keyof typeof criteriaLabels]}
              </h3>
              <div className={styles.scoreDisplay}>
                <span className={styles.score}>
                  {evaluation.score === 0 ? 1 : evaluation.score}
                </span>
                <span className={styles.maxScore}>/ {evaluation.maxScore}</span>
              </div>
            </div>
            {showComments && (
              <div className={styles.criteriaComments}>
                {evaluation.comments || 'Sin comentarios'}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CriteriaScoresSection;
